import PropTypes from 'prop-types';

import { useIntl } from '@zenbusiness/application-commons-intl';

import { businessTypes } from '#client/constants';

import Display from './Display';

import { formatAddress, formatContact } from '../helpers/formatData';

const NYPublication = ({
  title = 'Order Details',
  taskData: {
    standalone,
    nyPublicationCounty: nyPubCounty,
    name,
    type,
    jurisdiction,
    physicalAddress,
    mailingAddress,
    principalAddress,
    managerType,
    managers = [],
    members = [],
    registeredAgent: raWithEmail,
    contact,
  } = {},
  onClose,
}) => {
  const { formatMessage: fm } = useIntl();

  const ra = { ...raWithEmail, email: '' };

  const sections = [
    {
      title: fm({ id: 'orderView.items.publicationCounty' }),
      items: [{ content: nyPubCounty, xs: 12 }],
    },
  ];

  const standaloneSections = [
    {
      title: fm({ id: 'orderView.items.publicationCounty' }),
      items: [{ content: nyPubCounty, xs: 12 }],
    },
    {
      title: fm({ id: 'orderView.items.businessName' }),
      filter: !!name,
      items: [{ content: name, xs: 12 }],
    },
    {
      title: fm({ id: 'orderView.items.businessType' }),
      items: [{ content: businessTypes[type], xs: 12 }],
    },
    {
      title: fm({ id: 'orderView.items.formationState' }),
      items: [{ content: jurisdiction, xs: 12 }],
    },
    {
      title: fm({ id: 'orderView.items.addresses' }),
      items: [
        {
          label: fm({ id: 'orderView.items.physicalAddress' }),
          content: physicalAddress ? formatAddress(physicalAddress, fm) : fm({ id: 'orderView.items.none' }),
          xs: 12,
          md: 6,
        },
        {
          label: fm({ id: 'orderView.items.mailingAddress' }),
          content: mailingAddress ? formatAddress(mailingAddress, fm) : fm({ id: 'orderView.items.none' }),
          xs: 12,
          md: 6,
        },
        {
          label: fm({ id: 'orderView.items.principalAddress' }),
          content: principalAddress ? formatAddress(principalAddress, fm) : fm({ id: 'orderView.items.none' }),
          xs: 12,
          md: 6,
        },
      ],
    },
    {
      title: fm({ id: 'orderView.items.structure' }),
      filter: !!managerType,
      items: [{ content: managerType, xs: 12 }],
    },
    {
      title: fm({ id: 'orderView.items.managers' }),
      filter: managers !== null && managers.length > 0,
      items:
        managers &&
        managers.map((manager) => ({
          content: formatContact(manager, fm),
          xs: 12,
          md: 6,
        })),
    },
    {
      title: fm({ id: 'orderView.items.members' }),
      filter: members !== null && members.length > 0,
      items:
        members &&
        members.map((member) => ({
          content: formatContact(member, fm),
          xs: 12,
        })),
    },
    {
      title: fm({ id: 'orderView.items.registeredAgent' }),
      filter: !!raWithEmail,
      items: [{ content: formatContact(ra, fm), xs: 12 }],
    },
    {
      title: fm({ id: 'orderView.items.primaryContact' }),
      filter: !!contact,
      items: [{ content: formatContact(contact, fm), xs: 12 }],
    },
  ];

  return <Display onClose={onClose} sections={standalone ? standaloneSections : sections} title={title} />;
};

NYPublication.propTypes = {
  title: PropTypes.string,
  taskData: PropTypes.shape({
    standalone: PropTypes.bool,
    nyPublicationCounty: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    jurisdiction: PropTypes.string,
    physicalAddress: PropTypes.shape({}),
    mailingAddress: PropTypes.shape({}),
    principalAddress: PropTypes.shape({}),
    managerType: PropTypes.string,
    managers: PropTypes.arrayOf(PropTypes.shape({})),
    members: PropTypes.arrayOf(PropTypes.shape({})),
    registeredAgent: PropTypes.shape({}),
    contact: PropTypes.shape({}),
  }).isRequired,
  onClose: PropTypes.func.isRequired,
};

export default NYPublication;
